/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=5c2de637&"
import script from "./popover.vue?vue&type=script&lang=js&"
export * from "./popover.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./popover.vue?vue&type=style&index=0&id=5c2de637&prod&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports